import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/** Inline error banner + retry. Uses the warning token, never raw red. */
export const ErrorState = ({ title = "Noko gjekk gale", text, onRetry, retryLabel = "Prøv igjen", className, testId = "admin-error-state" }) => (
  <div role="alert" aria-live="assertive" className={cn("verdict-warn flex flex-col gap-3 rounded-xl border px-4 py-4 text-sm sm:flex-row sm:items-center", className)} data-testid={testId}>
    <AlertTriangle className="h-5 w-5 shrink-0 text-status-warning" aria-hidden="true" />
    <div className="min-w-0 flex-1">
      <p className="font-medium">{title}</p>
      {text && <p className="mt-0.5 text-muted-foreground">{text}</p>}
    </div>
    {onRetry && <Button variant="outline" size="sm" className="h-9 bg-card" onClick={onRetry} data-testid={`${testId}-retry`}><RefreshCw className="h-4 w-4" /> {retryLabel}</Button>}
  </div>
);

/** Soft notice (not an error) – e.g. “e-postvarsling er av”. */
export const Notice = ({ icon: Icon = AlertTriangle, title, text, action, className, testId = "admin-notice" }) => (
  <div role="status" className={cn("flex flex-col gap-3 admin-card px-4 py-3.5 text-sm sm:flex-row sm:items-center", className)} data-testid={testId}>
    <Icon className="h-5 w-5 shrink-0 text-status-warning" aria-hidden="true" />
    <div className="min-w-0 flex-1">
      {title && <p className="font-medium">{title}</p>}
      {text && <p className="text-muted-foreground">{text}</p>}
    </div>
    {action}
  </div>
);
